<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.KeepAlive && drawPage" />
    </keep-alive>
    <router-view v-if="!$route.meta.KeepAlive && drawPage" />
    <!-- 充值弹框 -->
    <TopUp />
    <!-- 邀请弹框 -->
    <InviteDialog />
    <!-- sse任务推流弹框 -->
    <SseNotification />
    <!-- iframe登录组件 -->
    <LoginDialog />
  </div>
</template>

<script>
import createWebSocket from "@/utils/websocket";
import { mapActions, mapGetters } from "vuex";
import TopUp from "./components/TopUp.vue";
import InviteDialog from "./components/InviteDialog";
import SseNotification from "./components/sseNotification";
import LoginDialog from "./components/loginDialog.vue";
import { getCookieVal } from "@/tool/index";
export default {
  name: "App",
  components: { TopUp, InviteDialog, SseNotification, LoginDialog },
  data() {
    return {
      visible: true,
      drawPage: false,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  watch: {
    token(val) {
      // 弹框登录后重新连接websocket
      createWebSocket().getSocket(this.updateCard);
    },
  },
  created() {
    // 获取apollo配置，可以动态添加key获取相应的配置数据
    // 数据将被存储来 vuex 中 apolloConfig
    // 使用 vuex getters 获取 指定的配置数据
    this.getConfig();
    this["toolConfig/getCaseConfig"]();
  },
  mounted() {
    if (getCookieVal("iyuanwu_token")) {
      createWebSocket().getSocket(this.updateCard);
    }
  },
  methods: {
    ...mapActions([
      "updateTaskDetail",
      "getApolloConfig",
      "toolConfig/getCaseConfig", // 获取工具所有案例配置
    ]),
    updateCard(val) {
      this.updateTaskDetail(val);
    },
    // 获取apollo配置
    async getConfig() {
      this.drawPage = false;
      await this.getApolloConfig({
        keys: [
          "ai_clothing_type",
          "model_options", // 通道生成模型配置
          "ai_video",
          "ai_agent_tool_config", // 爆款出图agent工具名称和loading对应配置
          "ai_imitation_prompt", // 爆款出图引导语配置
          "vector_search_merge_category", // 向量搜索分类配置
          "ai_gpt_tool_channel", // GPT 模型配置
          "optimize_write_prompt", // 是否开启提示词优化
        ],
      });
      this.drawPage = true;
    },
  },
};
</script>

<style lang="scss">
body {
  height: 100%;
  width: 100%;
}
/* canvas {
  cursor: none !important;
} */

#app {
  width: 100%;
  height: 100%;
}

.el-image-viewer__wrapper {
  &::after {
    position: absolute;
    bottom: 3px;
    font-size: 12px;
    left: 50%;
    color: #fff;
    transform: translate(-50%, 0);
    display: inline-block;
    text-align: center;
    height: 24px;
    padding: 0 16px;
    border-radius: 12px;
    line-height: 24px;
    background-color: #606266;
    width: 972px;
    content: "版权提醒：由于AI生成作品受用户指令生成，因此爱原物不保证AI生成作品的合法性，用户仍应当自行判断AI生成作品内容的合法性，并自行承担使用AI生成作品可能引发的法律责任。";
  }
}
</style>
